import React, { useEffect, useState } from "react";
import { sidebarItemIsActive } from "./sidebarRoutes";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SideBarDropdown from "./SideBarDropdown";
import { SideBarDropdownData } from "../../../constansts/LocalData";
import { ROLES } from "../../../constansts/Roles";
import DefaultLogo from "../../../assets/images/logo.png";
import SidebarFooterArt from "../../../assets/images/sidebar-footer.svg";
import { useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import usePermission from "../../../Hooks/custom-hooks/usePermission";

const CommonSideBar = () => {
   const navigate = useNavigate();
   const location = useLocation();
   const user = useSelector((state) => state?.auth?.user?.data?.user);
   const organization = useSelector((state) => state?.config?.configs?.organization || {});
   const organizationName = organization.organization_name || "Organization";
   const organizationLogo = organization.organization_logo || DefaultLogo;
   const { can, canAny } = usePermission();
   const [activeMenu, setActiveMenu] = useState(() => SideBarDropdownData.find((item) => !item.isDirectLink && sidebarItemIsActive(item, location.pathname))?.menuName || "");
   useEffect(() => {
      setActiveMenu(SideBarDropdownData.find((item) => !item.isDirectLink && sidebarItemIsActive(item, location.pathname))?.menuName || "");
   }, [location.pathname]);
   const isDashboardActive =
      location?.pathname === "/dashboard" || location?.pathname === "/";
   const isUserActive =
      location?.pathname === "/user/view" ||
      location?.pathname?.startsWith("/user/");


   return (
      <aside className="main-sidebar sidebar-dark-primary elevation-4 oil-sidebar">
         <Link to="/dashboard" className="brand-link oil-sidebar__brand">
            <img src={organizationLogo} alt={organizationName} className="oil-sidebar__logo" />
            <span className="brand-text oil-sidebar__brand-text">{organizationName}</span>
         </Link>

         <div className="sidebar oil-sidebar__body">
            <nav className="oil-sidebar__nav mt-4">
               <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
               >
                  <List className="oil-sidebar__menu-list" disablePadding>
                     {SideBarDropdownData.filter((item) =>
                        !item.permission || (Array.isArray(item.permission)
                           ? canAny(item.permission)
                           : can(item.permission))
                     ).map((item, index) => {
                        if (item.isDirectLink) {
                           const isActive = sidebarItemIsActive(item, location.pathname);

                           return (
                              <div key={index.toString()} className={`oil-sidebar__dropdown ${isActive ? "has-active" : ""}`}>
                                 <ListItemButton
                                    className={`oil-sidebar__link oil-sidebar__parent ${isActive ? "active" : ""}`}
                                    aria-current={isActive ? "page" : undefined}
                                    onClick={() => navigate(item.url)}
                                 >
                                    <ListItemIcon className="oil-sidebar__icon" sx={{ minWidth: 28 }}>
                                       <i className={`nav-icon fas ${item.icon}`} />
                                    </ListItemIcon>
                                    <ListItemText primary={item.menuName} className="oil-sidebar__label" />
                                 </ListItemButton>
                              </div>
                           );
                        }

                        return (
                           <SideBarDropdown
                              label={item.menuName}
                              url={item.url}
                              icon={item.icon}
                              dropdownList={(item.dropdownList || []).filter((subItem) => {
                                 // Sub-item has its own permission — check directly
                                 if (subItem.permission) return can(subItem.permission);

                                 // No own permission but nested items have permissions
                                 // — show only if user has at least one nested permission
                                 const nestedPermissions = subItem.subDropdownList
                                    ?.filter((n) => n.permission)
                                    .map((n) => n.permission);

                                 if (nestedPermissions?.length > 0)
                                    return canAny(nestedPermissions);

                                 // No permissions required at any level — always show
                                 return true;
                              })}
                              isOpen={activeMenu === item.menuName}
                              onToggle={() =>
                                 setActiveMenu((prev) =>
                                    prev === item.menuName ? "" : item.menuName
                                 )
                              }
                              key={index.toString()}
                           />
                        );
                     })}
                   </List>
               </ul>
            </nav>

            <div className="oil-sidebar__footer" aria-hidden="true">
               <img src={SidebarFooterArt} alt="" className="oil-sidebar__footer-art" />
            </div>
         </div>
      </aside>
   );
};

export default CommonSideBar;
